import { createSlice } from '@reduxjs/toolkit';

const languageSlice = createSlice({
  name: 'language',
  initialState: { language: 'ca' },
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload; // Redux Toolkit permite "mutar" el estado de forma segura
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;